<template>
  <InfuseSelect
    name="type"
    size="small"
    :disabled="disabled"
    :options="options"
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    autofocus
    required
  />
</template>

<script setup lang="ts">
import { UserLevel } from '@infuse/iam/user/type';
import { InfuseSelect } from '@infuse/ui/components';
import { computed } from 'vue';
import { Locale } from 'vue-i18n';
import { languages } from '@infuse/ui/utils';

withDefaults(
  defineProps<{
    modelValue: string;
    availableLocales?: Locale[];
    required?: boolean;
    disabled?: boolean;
  }>(),
  {
    level: UserLevel.DOMAIN,
    parentId: undefined
  }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const options = computed(() =>
  languages.map((lang) => ({
    value: lang.value,
    key: `${lang.emoji} ${lang.label}`
  }))
);
</script>

<style>
@import '@vueform/multiselect/themes/default.css';
</style>
